import styled from '@emotion/styled';
import { FlexDivProps } from './types';

/**
 * @deprecated Use Tailwind flex utilities (`flex`, `flex-col`, `justify-*`,
 * `items-*`, `gap-*`, etc.) directly on a `<div>` instead.
 */
export const FlexDiv = styled.div<FlexDivProps>`
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'center'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  padding: ${(props) => props.padding || '0px'};
  gap: ${(props) => props.gap || '8px'};
  position: ${(props) => props.position || undefined};
`;
